export const DURATION_TOAST = 2000;
export const DURATION_TOAST_LONG = 7000;
export const delayDispatchUploadImage = 100;
